<div #container class="flex w-0 h-screen gap-1 left-1/2 fixed top-0 flex-col items-center justify-end py-20 z-max">
<div class="px-5 flex flex-col items-stretch max-w-4xl minw-96 gap-1" [style.direction]="dir">
    <div *ngFor="let message of messages">
        <div [@fadeUpDown] *ngIf="message.show"
            class="flex flex-row justify-between items-stretch px-5 py-4 rounded-md z-max bottom-0 height-fit "
            [ngClass]="{'bg-zen-red':message.type == 'error','bg-int':message.type == 'info','bg-zen-orange':message.type == 'warning','bg-zen-green':message.type == 'success'}">
            <div class="flex flex-row gap-3">
                <i [ngClass]="{'fa-times-circle':message.type == 'error','fa-circle-exclamation':message.type == 'info','fa-triangle-exclamation':message.type == 'warning','fa-check-circle':message.type == 'success'}"
                    class="fa-regular text-5xl text-white"></i>
                <div class="flex flex-col gap-2 w-96">
                    <h5 class="text-lg text-white firstLetterUpper">{{ message.type|translate:language:ModuleNames.Shared }}</h5>
                    <p class="text-sm text-white whitespace-normal textStart">{{ message.message }}</p>
                </div>
                <!-- <i class="fa-light fa-times btn bg-transparent text-white" (click)="data.preClose();"></i> -->
            </div>
    
        </div>
    </div>
</div>
</div>